import script from "./ManageAffiliationView.vue?vue&type=script&setup=true&lang=ts"
export * from "./ManageAffiliationView.vue?vue&type=script&setup=true&lang=ts"

import "./ManageAffiliationView.vue?vue&type=style&index=0&id=37d031df&lang=css"

const __exports__ = script;

export default __exports__